import React, { useState } from "react";
import FontIcon from "react-md/lib/FontIcons";

function RefreshButton({ onRefresh, loading }) {
  const [isRotating, setIsRotating] = useState(false);

  const handleClick = () => {
    setIsRotating(true);
    if (onRefresh && loading === false) onRefresh();

    setTimeout(() => setIsRotating(false), 300);
  };

  return (
    <div
      onClick={handleClick}
      style={{
        display: "inline-block",
        cursor: "pointer",
        transition: "transform 0.3s ease",
        transform: isRotating ? "rotate(180deg)" : "rotate(0deg)",
      }}
    >
      <FontIcon style={{ fontSize: "25px", color: "#F97E0F" }}>
        refresh
      </FontIcon>
    </div>
  );
}

export default RefreshButton;
